import type { ResourceListDataObject } from '#models';

// TODO: remove whole file once BE introduces the new endpoint

const baseResources: ResourceListDataObject[] = [
  {
    _id: 'resource-1',
    hoursOfOperation: ['Mon, Wed: 9:00 AM to 5:30 PM', 'Tue, Thu - Fri: 9:00 AM to 4:00 PM'],
    isDueForRecheck: true,
    lastVerifiedAt: '2026-09-07T00:00:00.000Z',
    organizationName: 'Title',
    requirementsEligibility:
      'Applicants must have a gross annual household income at or below 30% of the Area Median Income (AMI) for the county in which they reside.',
    status: 'active',
    type: 'food',
    websiteUrl: 'https://sum.domain.com',
    whoTheyServe: 'Low to moderate income individuals and families.',
  },
  {
    _id: 'resource-2',
    hoursOfOperation: ['Mon - Fri: 8:00 AM to 6:00 PM'],
    isDueForRecheck: false,
    lastVerifiedAt: '2026-02-14T00:00:00.000Z',
    organizationName: 'Chicago Community Pantry',
    requirementsEligibility: 'Open to all residents of Cook County. Photo ID required for first visit.',
    status: 'active',
    type: 'food',
    websiteUrl: 'https://chicago-pantry.example.org',
    whoTheyServe: 'Individuals and families experiencing food insecurity in the Chicago metro area.',
  },
  {
    _id: 'resource-3',
    hoursOfOperation: ['Tue, Thu: 10:00 AM to 3:00 PM', 'Sat: 9:00 AM to 12:00 PM'],
    isDueForRecheck: true,
    lastVerifiedAt: '2025-11-20T00:00:00.000Z',
    organizationName: 'Northside Housing Alliance',
    requirementsEligibility:
      'Must be at risk of eviction or experiencing homelessness. Referral from a caseworker preferred.',
    status: 'inactive',
    type: 'housing',
    websiteUrl: 'https://northside-housing.example.org',
    whoTheyServe: 'Adults and families seeking emergency shelter and rapid rehousing support.',
  },
  {
    _id: 'resource-4',
    hoursOfOperation: ['Mon - Fri: 9:00 AM to 5:00 PM'],
    isDueForRecheck: false,
    lastVerifiedAt: '2026-01-08T00:00:00.000Z',
    organizationName: 'West Loop Health Clinic',
    requirementsEligibility: 'Uninsured and underinsured patients welcome. Appointments required for specialty care.',
    status: 'active',
    type: 'health',
    websiteUrl: 'https://westloop-clinic.example.org',
    whoTheyServe: 'Uninsured adults and children in zip codes 60607, 60608, and 60610.',
  },
  {
    _id: 'resource-5',
    hoursOfOperation: ['Wed: 1:00 PM to 7:00 PM', 'Sat: 10:00 AM to 2:00 PM'],
    isDueForRecheck: true,
    lastVerifiedAt: '2025-08-30T00:00:00.000Z',
    organizationName: 'Skills Forward Center',
    requirementsEligibility: 'Participants must be 18 or older and authorized to work in the United States.',
    status: 'pending',
    type: 'employment',
    websiteUrl: 'https://skills-forward.example.org',
    whoTheyServe: 'Job seekers re-entering the workforce after incarceration or long-term unemployment.',
  },
];

const createMockResource = (index: number): ResourceListDataObject => {
  const template = baseResources[index % baseResources.length];

  if (!template) {
    return {
      _id: 'resource-5',
      hoursOfOperation: ['Wed: 1:00 PM to 7:00 PM', 'Sat: 10:00 AM to 2:00 PM'],
      isDueForRecheck: true,
      lastVerifiedAt: '2025-08-30T00:00:00.000Z',
      organizationName: 'Skills Forward Center',
      requirementsEligibility: 'Participants must be 18 or older and authorized to work in the United States.',
      status: 'active',
      type: 'employment',
      websiteUrl: 'https://skills-forward.example.org',
      whoTheyServe: 'Job seekers re-entering the workforce after incarceration or long-term unemployment.',
    };
  }

  return {
    ...template,
    _id: `resource-${index + 1}`,
    organizationName:
      index < baseResources.length ? template.organizationName : `${template.organizationName} ${index + 1}`,
  };
};

export const resourcesMockCatalog: ResourceListDataObject[] = Array.from({ length: 354 }, (_, index) =>
  createMockResource(index),
);
